// import React from "react";
// import "../css/GlitchButton.css"; // Import the custom styles


// const GlitchButton = ({ text = "Button 49" }) => {
//   return (
//     <button className="button-49" role="button">
//       {text}
//     </button>
//   );
// };

// export default GlitchButton;


import React from "react";
import ButtonImage from "../assets/Button-Orange.png"; 

const GlitchButton = ({ text, onClick }) => {
  return (
    <button
      className="w-[150px] h-[70px] text-xs sm:text-base sm:w-[280px] sm:h-[80px] bg-no-repeat bg-center bg-contain flex items-center justify-center text-white font-bold z-999 relative"
      style={{ backgroundImage: `url(${ButtonImage})` }}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default GlitchButton;
